import { connect } from 'react-redux';

/*
  This HOC deviates from other connectHOCs. Here, we also have subscribe to relevant proxy for fetching data.
  We can create a new namespacec outside connectHOCs to contain such HOCs that also subscribe.
 */

const mapStateToProps = state => {
  const {
    _session: { all_session_ids: allSessionIds },
  } = state.restricted;
  return {
    allSessionIds,
  };
};

export default function(Component) {
  return connect(
    mapStateToProps,
    null
  )(Component);
}



// WEBPACK FOOTER //
// ./src/connectHOCs/Sessions/allSessions.js